import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=538904ea&scoped=true&"
import script from "./Lobby.vue?vue&type=script&lang=js&"
export * from "./Lobby.vue?vue&type=script&lang=js&"
import style0 from "./Lobby.vue?vue&type=style&index=0&id=538904ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538904ea",
  null
  
)

component.options.__file = "Lobby.vue"
export default component.exports